import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { iconStyles } from '../styles/icons.js';

@customElement('hg-stat')
export class HgStat extends LitElement {
  static styles = [
    iconStyles,
    css`
      :host {
        display: block;
      }
      .card {
        height: 100%;
        padding: 18px;
        border-radius: 14px;
        background: var(--hg-white);
        border: 1px solid var(--hg-line);
        box-shadow: var(--md-sys-elevation-1);
      }
      .icon {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        display: grid;
        place-items: center;
        background: var(--hg-forest-tint);
        color: var(--hg-forest);
        margin-bottom: 14px;
      }
      .icon .material-symbols-outlined {
        font-size: 1.1rem;
      }
      .value {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
      }
      .label {
        font-size: 12.5px;
        color: var(--hg-muted);
        margin-top: 4px;
      }
      .desc {
        display: none;
      }
    `,
  ];

  @property() icon = 'analytics';
  @property() label = '';
  @property() value = '';
  @property() description = '';

  render() {
    return html`
      <div class="card">
        <div class="icon"><span class="material-symbols-outlined">${this.icon}</span></div>
        <div class="value">${this.value}</div>
        <div class="label">${this.label}</div>
        <div class="desc">${this.description}</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hg-stat': HgStat;
  }
}
